module.exports = __webpack_public_path__ + "static/media/outline-icons.ef60a4f6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/outline-icons.woff
// module id = 4409
// module chunks = 0